module.exports = __webpack_public_path__ + "static/media/dark-theme-adblue-low.b3f93f33.svg";